<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium required-field">Название</label>
            <crm-input-text
              [(value)]="bucket.name"
              [isError]="$any(errors?.name)"></crm-input-text>
            <small
              *ngIf="errors?.name"
              class="p-error">
              {{ errors.name | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Путь в S3</label>
            <crm-input-text
              [(value)]="bucket.path"
              [isError]="$any(errors?.path)"></crm-input-text>
            <small
              *ngIf="errors?.path"
              class="p-error">
              {{ errors.path | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Хранилище S3</label>
            <crm-storage-single-select
              [(selectedStorage)]="bucket.storage"
              [styleClass]="errors?.storage ? 'ng-invalid ng-dirty' : ''"
              [class]="errors?.storage ? 'ng-invalid ng-dirty' : ''"
              appendTo="body"></crm-storage-single-select>
          </div>

          <div class="field-checkbox col-12">
            <p-checkbox
              [(ngModel)]="bucket.isDefault"
              [binary]="true"
              inputId="isDefault"></p-checkbox>
            <label [for]="'isDefault'">Используется по-умолчанию</label>
          </div>
        </div>
      </p-card>
    </div>
  </div>

  <div class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <crm-button
        styleClass="p-button-success"
        [label]="saveButtonLabel"
        (onClick)="saveBucket()"></crm-button>

      <crm-button
        label="Удалить"
        styleClass="p-button-danger p-button-text"
        (onClick)="deleteBucket()"></crm-button>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
